/**
 * Remove extra simulation rounds that have not been reached yet
 */
export default {
  applyToVersions: "<2.3.8",
  type: "before",
  name: "make effect structure clearer",
  migrate(data) {
    if (data?.effects == null) return data;

    for (const effectId in data.effects.items) {
      const effect = data.effects.items[effectId];

      if (effect.title == null) continue;

      delete effect.title;
      delete effect.description;
      if (effect?.docs) {
        for (const docId in effect.docs) {
          const doc = effect.docs[docId];
          effect.docs.main = doc;
          delete effect.docs[docId];
        }
      }
    }

    return data;
  }
};
